import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import MaintenancePage from "../pages/MaintenancePage";

// During maintenance, non-admins see the maintenance page. Admins keep full access,
// and the login/verify/admin routes stay open so an admin can get in and switch it off.
const ALLOWED_PREFIXES = ["/admin", "/login", "/verify"];

export default function MaintenanceGate({ children }) {
  const { config, user, loading } = useAuth();
  const { pathname } = useLocation();

  const isAdmin = user?.role === "admin";
  const onAllowedRoute = ALLOWED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p));

  if (!loading && config?.maintenance_mode && !isAdmin && !onAllowedRoute) {
    return <MaintenancePage message={config.maintenance_message} until={config.maintenance_until} />;
  }
  return children;
}
